module.exports = __webpack_public_path__ + "static/media/animal-attendant.011e391a.jpg";